import { useState } from "react";

export const useLocalStorage = (key, initialValue) => {
  const [state, setState] = useState(getStorage(key) ?? initialValue);
  const setStored = (value) => {
    setState(value);
    setStorage(key, value);
  };
  return [state, setStored];
};

const getStorage = (key) => JSON.parse(localStorage.getItem(key));
const setStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));
